import * as moment from 'moment';

const format = 'DD.MM.YYYY HH:mm:ss';

export const formatDate = (date) => {
  return moment(date).format(format)
};



// WEBPACK FOOTER //
// ./src/utils/format-date.js